export default __webpack_public_path__ + "static/media/Pistol_6.4c9168dd.png";